var _PlusCircle, _Trash;
import clsx from 'clsx';
import PlusCircle from '@crehana/compass.icons.outline/PlusCircle';
import Trash2 from '@crehana/compass.icons.outline/Trash2';
import { useTranslation } from '@crehana/i18n';
import { Button } from "../Button";
import locales from "./i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ListActionsLayout(_ref) {
  var items = _ref.items,
    canAdd = _ref.canAdd,
    canDeleteAll = _ref.canDeleteAll,
    onItemChange = _ref.onItemChange,
    onAddItem = _ref.onAddItem,
    onDeleteItem = _ref.onDeleteItem,
    onDeleteAll = _ref.onDeleteAll,
    children = _ref.children,
    className = _ref.className,
    footerActions = _ref.footerActions;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  return /*#__PURE__*/_jsxs("section", {
    className: clsx('tw-w-full tw-space-y-1', className),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "tw-w-full tw-p-1.2 tw-bg-neutral-light-300 tw-rounded-1.2",
      children: [items.map(function (item, index) {
        return /*#__PURE__*/_jsx("div", {
          children: children({
            onChange: function onChange(value) {
              return onItemChange(value, index);
            },
            onDelete: function onDelete() {
              return onDeleteItem(index);
            },
            defaultValue: item.value
          })
        }, item.id);
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-items-center tw-justify-between",
        children: [/*#__PURE__*/_jsxs(Button, {
          type: "button",
          variant: "cancel",
          className: clsx(!canAdd ? '!tw-text-neutral-light-500 tw-opacity-50 tw-pointer-events-none' : '!tw-text-primary-light-500'),
          onClick: onAddItem,
          children: [_PlusCircle || (_PlusCircle = /*#__PURE__*/_jsx(PlusCircle, {
            size: 20,
            className: "tw-text-current"
          })), locales[languageCode].ADD_ITEM]
        }), /*#__PURE__*/_jsxs(Button, {
          type: "button",
          variant: "cancel",
          className: clsx(!canDeleteAll ? '!tw-text-neutral-light-500 tw-opacity-50 tw-pointer-events-none' : '!tw-text-alert-500'),
          onClick: onDeleteAll,
          children: [_Trash || (_Trash = /*#__PURE__*/_jsx(Trash2, {
            size: 20,
            className: "tw-text-current"
          })), locales[languageCode].DELETE_ALL]
        })]
      })]
    }), footerActions]
  });
}